module.exports = __webpack_public_path__ + "img/ramada-by-wyndham-lisbon-hotel.7461fac9.jpg";